import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	synonyms: [],

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const SynonymSlice = createSlice({
	name: 'synonym',
	initialState,
	reducers: {

		clearSynonymList: (state, action) => {
			return { ...state, synonyms: [] };
		},

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},


		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, synonyms: action.payload.data, gettingList: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},

		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},

		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},

		onFailList: (state, action) => {
			return {...state, synonyms: [] };
		},
	},
});

export const {
	clearSynonymList,
	clearSynonymSearchResult
} = SynonymSlice.actions;
